var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partners"},_vm._l((_vm.List),function(item){return _c('div',{key:item.id},[_c('div',[_c('img',{attrs:{"src":item.picLink,"alt":""}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }